import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './checklists.actions';
import { BusinessChecklistVM } from '@models/checklist';
import { SortOption } from './checklists.types';
import { MatterFileType } from '@models/matter';

@Injectable({
	providedIn: 'root',
})
export class BusinessChecklistsDispatch {
	@Dispatch()
	Create = (
		checklistItems: BusinessChecklistVM,
		oldItemIds?: string[],
	): actions.Create => new actions.Create({ checklistItems, oldItemIds });

	@Dispatch()
	SetDefault = (id: string): actions.SetDefault => new actions.SetDefault(id);

	@Dispatch()
	DeleteItems = (ids: string[]): actions.DeleteItems =>
		new actions.DeleteItems(ids);

	@Dispatch()
	Remove = (templateId: string): actions.Remove =>
		new actions.Remove(templateId);

	@Dispatch()
	UpdateSortOption = (sortOption: SortOption): actions.UpdateSortOption =>
		new actions.UpdateSortOption(sortOption);

	@Dispatch()
	UpdateSelectedFileType = (
		selectedFileType: MatterFileType | 'all',
	): actions.UpdateSelectedFileType =>
		new actions.UpdateSelectedFileType(selectedFileType);
}
